import { Button, Dialog, DialogContent } from "@mui/material";
import { PanelActions, PanelHeader } from "./Panel";

/**
 * Shared confirmation dialog (empty trash, debug delete-all, etc.).
 * Render conditionally: `{confirmOpen ? <ConfirmDialog ... /> : null}`.
 */
export function ConfirmDialog({
  titleId,
  title,
  description,
  confirmLabel,
  closeAriaLabel,
  pending = false,
  error = "",
  onConfirm,
  onClose,
}: {
  titleId: string;
  title: string;
  description: string;
  confirmLabel: string;
  closeAriaLabel: string;
  pending?: boolean;
  error?: string;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Dialog open onClose={onClose} aria-labelledby={titleId} slotProps={{ paper: { className: "modal records-modal confirm-modal" } }}>
      <DialogContent className="records-modal-content">
        <PanelHeader titleId={titleId} title={title} closeAriaLabel={closeAriaLabel} onClose={onClose} />
        <p className="confirm-copy">{description}</p>
        <PanelActions>
          <Button variant="outlined" type="button" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="outlined" color="error" type="button" disabled={pending} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </PanelActions>
        {error ? <p className="status error">{error}</p> : null}
      </DialogContent>
    </Dialog>
  );
}
